import { useCallback, useEffect, useState } from "react";
var useScreenSize = function () {
    var _a = useState(0), height = _a[0], setHeight = _a[1];
    var _b = useState(0), width = _b[0], setWidth = _b[1];
    var updateWidth = useCallback(function () {
        setWidth(Math.max(window.innerWidth, document.documentElement.clientWidth));
    }, []);
    var updateHeight = useCallback(function () {
        setHeight(Math.max(window.innerHeight, document.documentElement.clientHeight));
    }, []);
    useEffect(function () {
        updateWidth();
        updateHeight();
        window.addEventListener("resize", function () {
            updateWidth();
            updateHeight();
        });
    }, [updateWidth, updateHeight]);
    return { height: height, width: width };
};
export default useScreenSize;
//# sourceMappingURL=useScreenSize.js.map